var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIdCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16.216,
    viewBox: "0 0 24 16.216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.d{fill:none;}.a,.b{stroke:#496482;stroke-miterlimit:10;}.a{stroke-width:2px;}.b{fill:#496482;stroke-width:0.2px;}.c{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-311.5 -439)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(311.5 439)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 24,
    height: 16.216,
    rx: 4.054
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 1,
    y: 1,
    width: 22,
    height: 14.216,
    rx: 3.054
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(314.743 442.892)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 5.189,
    height: 4.541,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 1,
    y: 1,
    width: 3.189,
    height: 2.541,
    rx: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(324.444 442.761)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M337.108,453.216a.579.579,0,1,1-1.158,0,2.9,2.9,0,0,0-5.792,0,.579.579,0,1,1-1.158,0,4.054,4.054,0,0,1,8.108,0m-4.054-7.956a1.158,1.158,0,1,1-1.158,1.159,1.159,1.159,0,0,1,1.158-1.159m0,3.475a2.317,2.317,0,1,0-2.317-2.317,2.319,2.319,0,0,0,2.317,2.317",
    transform: "translate(-329 -444.102)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdCard);
export default __webpack_public_path__ + "static/media/id-card.801d39906045d83c9375d4c63fda3d69.svg";
export { ForwardRef as ReactComponent };